import React from "react";
import { INoticeDetails } from "../../../models/interfaces/INotice";



interface IProps {
  NoticeResult: INoticeDetails;
}

const Bloc11: React.FC<IProps> = ({ NoticeResult }) => {
  return (
    <>
    {NoticeResult?.autresFormats?.length>0 && (
      <div className="card" style={{ textAlign: 'left' }}>
        <div className="col-sm-12 card-body pae-card-grey" >
          <b className="pae-detail-section-title mb-2">Autres formats</b>
        </div>
        <div className="col-sm-12 card-body">
          {NoticeResult?.autresFormats?.map((item,index) => (
            <>
            {
              <><span key={index}>Livre {item.formatLivreLie?.toLowerCase() === 'livre' ? 'grand format' : item.formatLivreLie}</span><br/></>
            }
            </>
          ))}
        </div>
      </div>  
    )}     
    </>
  );
};

export default Bloc11;
